import { render, staticRenderFns } from "./ChatMsg.vue?vue&type=template&id=05b6bde0"
import script from "./ChatMsg.vue?vue&type=script&lang=js"
export * from "./ChatMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports